import { Box, Table, Tbody, Td, Th, Thead, Tr } from '@elkaso-app/web-design';
import { ISimilarProduct } from '../utils/types';

interface CompetitorSuppliersSectionProps {
  similarProducts: ISimilarProduct[];
}

export const CompetitorSuppliersSection = ({ similarProducts }: CompetitorSuppliersSectionProps) => (
  <Box>
    <Table variant='simple' size='sm'>
      <Thead>
        <Tr>
          <Th>Product Name</Th>
          <Th>Supplier</Th>
          <Th>Brand</Th>
          <Th>Unit</Th>
          <Th isNumeric>Price (AED)</Th>
          <Th isNumeric>Similarity</Th>
        </Tr>
      </Thead>
      <Tbody>
        {similarProducts.flatMap((p) =>
          p.suppliers.map((s) => (
            <Tr key={s.id}>
              <Td fontWeight='medium'>{p.nameEn}</Td>
              <Td>{s.supplierName}</Td>
              <Td>{s.brandEn ?? '—'}</Td>
              <Td>{p.defaultUnit ?? '—'}</Td>
              <Td isNumeric>{(s.defaultPrice ?? 0).toFixed(2)}</Td>
              <Td isNumeric>{p.similarityScore}%</Td>
            </Tr>
          ))
        )}
      </Tbody>
    </Table>
  </Box>
);
